<template>
  <div id="app">
    <Header />
    <main v-if="!locationEnabled" class="main main--preload">
      <p>
        Hey there. We'd like to show you some venues near you, but to do so,
        we'll need to get your location!
      </p>
      <button class="button" @click="getLocation">Search Venues</button>
    </main>
    <main v-else class="main">
      <p v-if="venuesLoading">Loading...</p>
      <transition-group name="venue-list" class="venue-list" tag="ul">
        <VenueListItem
          v-for="venue in venues"
          :key="venue.id"
          :venue="venue"
          :range="distanceRange"
        />
      </transition-group>
    </main>
  </div>
</template>

<script>
import { mapState } from "vuex";

import VenueListItem from "./components/VenueListItem";
import Header from "./components/Header";

export default {
  name: "app",
  components: { VenueListItem, Header },
  data() {
    return {
      radius: 250,
      latitude: 0,
      longitude: 0
    };
  },
  computed: {
    ...mapState({
      locationEnabled: state => state.map.locationEnabled,
      venues: state => state.map.venues,
      venuesLoading: state => state.map.loading
    }),
    distanceRange() {
      const max = Math.max.apply(
        Math,
        this.venues.map(venue => venue.location.distance)
      );
      const min = Math.min.apply(
        Math,
        this.venues.map(venue => venue.location.distance)
      );
      return [min, max];
    }
  },
  methods: {
    getLocation() {
      this.$store.dispatch("map/enableLocation", true);
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(position => {
          const { latitude, longitude } = position.coords;
          this.latitude = latitude;
          this.longitude = longitude;
          this.getVenues({ latitude, longitude, radius: this.radius });
        });
      }
    },
    getVenues({ latitude, longitude, radius }) {
      if (this.locationEnabled) {
        this.$store.dispatch("map/getVenues", {
          latitude,
          longitude,
          radius
        });
      }
    },
    handleRadiusChange() {
      this.getVenues({
        latitude: this.latitude,
        longitude: this.longitude,
        radius: this.radius
      });
    }
  }
};
</script>

<style lang="scss">
@import "./scss/utilities";
#app {
  min-height: 100vh;
}
.button {
  border: 0;
  width: 100%;
  background-color: var(--color--neutral);
  color: var(--color--contrast);
  padding: 1rem;
  font-size: 1.2rem;
  font-weight: 670;
  cursor: pointer;
  border-radius: 0.2rem;
}
.venue-list {
  list-style-type: none;
  padding: 0;
  display: grid;
  grid-gap: 1.5rem;
  @for $i from 1 through 30 {
    :nth-child(#{$i}) {
      transition-delay: #{$i * 0.05}s;
    }
  }
}
.main {
  @include container;
}
.loading-indicator {
  &-enter-active,
  &-leave-active {
    transition: all 200ms;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
.venue-list {
  &-enter-active,
  &-leave-active {
    transition: all 300ms;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(-0.2rem);
  }
}
</style>
